import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        <div>
            <div className="footer">
                <p className="text-center p-2">© 2019-2021 Madang, Inc. ALL RIGHT RESERVED.</p>

            </div>

        </div>
    );
};

export default Footer;